import {
    Container,
    MainContentWrapper,
    MainContent,
    Heading
} from '../../styles/account/account'
import { DashboardWrapper } from '../../container/dashboardWrapper'
import { Breadcrumb } from '../../components/breadcrumb/breadcrumb'
import { ModuleHeader } from '../../components/module-header'
import { Announcements as AnnouncementFeed } from "../../components/dashboard-announcements";
const Announcements = () => {
    return (
        <DashboardWrapper>
            <MainContentWrapper fullHeight>
                <Container>
                    <MainContent>
                        <Heading>
                            Announcements
                        </Heading>
                        <Breadcrumb
                            crumbs={['Announcements']}
                        />
                        <ModuleHeader title="ANNOUNCEMENT FEED" />
                        <AnnouncementFeed search />
                    </MainContent>
                </Container>
            </MainContentWrapper>
        </DashboardWrapper>
    )
}

export default Announcements
